import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

import ElementUI from "element-ui";
import "./style.scss";
import lang from "element-ui/lib/locale/lang/pt-br";
import locale from "element-ui/lib/locale";

locale.use(lang);
Vue.use(ElementUI);
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
